import { StoreEditor } from './RadStore';

export default function BadManorzStore() {
  return (
    <StoreEditor
      prefix="bad_manorz_"
      storeLabel="Bad Manorz Store"
      storeBaseUrl="https://bad-manorz-main.pages.dev"
    />
  );
}
